import { BeketTicket } from 'shared/api/beket/search'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { dateFormat, showWrongDateFormat } from 'shared/lib/dateFormat.ts'
import { ResultCardDetail } from 'shared/ui/result-card-details/model.ts'

export const prepareBeketRouteData = (
  routeData: BeketTicket | null,
): ResultCardDetail | null => {
  if (!routeData) return null

  const { city: cityFrom, address: addressFrom } =
    routeData?.route?.arrival_station

  const { city: cityTo, address: addressTo } =
    routeData?.route?.departure_station

  return {
    duration: routeData?.duration,
    arrival: {
      time: dateFormat(routeData?.arrival_datetime, DATE_FORMAT_LIST.TIME),
      date: showWrongDateFormat(
        routeData?.arrival_datetime,
        DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY,
        ',',
        true,
      ),
      city: cityFrom,
      station: cityFrom === addressFrom ? '' : addressFrom,
    },
    departure: {
      time: dateFormat(routeData?.departure_datetime, DATE_FORMAT_LIST.TIME),
      date: showWrongDateFormat(
        routeData?.departure_datetime,
        DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY,
        ',',
        true,
      ),
      city: cityTo,
      station: cityTo === addressTo ? '' : addressTo,
    },
  }
}
